import {
  RECEIVE_TEAMS,
} from '../constants';

const teams = (state = [], action) => {
  switch(action.type) {
    case RECEIVE_TEAMS:
      return [...action.teams]
    default:
      return state;
  }
}

export default teams;


// WEBPACK FOOTER //
// ./src/shared/javascripts/reducers/teamsReducer.js